import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../actions/AppActions';
import { URL as API_BASE } from '../../variables';
import { authenticatedFile } from '../../services/authenticatedFile';

export default function AuthenticatedFileLink({ path, token, file, children, ...props }) {
  const dispatch = useDispatch();
  const pending = useRef(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const url = `${API_BASE}api/${path}`;
  const open = async event => {
    event.preventDefault();
    if (pending.current) return;
    pending.current = true;
    setLoading(true);
    setError('');
    const tab = window.open('', '_blank');
    if (tab) {
      tab.opener = null;
      tab.document.title = 'Carregando documento';
      tab.document.body.textContent = 'Preparando o documento. Aguarde…';
    }
    try {
      if (!tab) throw new Error('Permita abrir outra aba no navegador para visualizar o documento.');
      const blob = await authenticatedFile(url, token);
      const objectUrl = window.URL.createObjectURL(blob);
      tab.location.replace(objectUrl);
      window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 5 * 60 * 1000);
    } catch (failure) {
      if (tab) tab.close();
      if (failure.status === 401) dispatch(logout());
      setError(failure.message);
    } finally {
      pending.current = false;
      setLoading(false);
    }
  };
  if (file) return <a {...props} href={file} target="_blank" rel="noopener noreferrer">{children}</a>;
  return <>
    <a {...props} href={url} target="_blank" rel="noopener noreferrer" onClick={open} onAuxClick={event => { if (event.button === 1) open(event); }} aria-disabled={loading} aria-busy={loading}>
      {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-label="Carregando documento" /> : children}
    </a>
    {error && <span className="d-block text-danger mt-1" role="alert">{error}</span>}
  </>;
}
